import Typography from '@mui/material/Typography';
import {arrayOf, string} from 'prop-types';
import React, {Fragment} from 'react';
import {getNewSearchUrl, quoteSpaced} from '../utils.js';
import Link from './Link.jsx';

function PublicationKeywords({keywords}) {
  if (keywords.length === 0) {
    return null;
  }

  return (
    <Typography variant="caption" sx={{marginY: 2}} component="p">
      Keywords:{' '}
      {keywords.map((keyword, i) => (
        <Fragment key={keyword}>
          {i > 0 ? ', ' : ''}
          <Link to={getNewSearchUrl({query: quoteSpaced(keyword)})}>
            {keyword}
          </Link>
        </Fragment>
      ))}
    </Typography>
  );
}

PublicationKeywords.propTypes = {
  keywords: arrayOf(string).isRequired,
};

export default PublicationKeywords;
